import React, { Component, Suspense} from 'react';
import './style.scss';
import {withRouter} from 'react-router-dom';
import { LanguageContext } from '../../providers/LanguageProvider';
//import {TranslatableText} from '../../providers/LanguageProvider';
import HeroLTO from './HeroLTO/HeroLTO';
import Wrapper from '../../templates/Wrapper/Wrapper';
//import ContainerContent from '../../templates/ContainerContent/ContainerContent';
import SubPromo1 from './SubPromo1/SubPromo1';
import SubPromo2 from './SubPromo2/SubPromo2';
import NowHiring from '../../components/NowHiring/NowHiring';
import MobileOrderBanner from '../../components/MobileOrderBanner/MobileOrderBanner';
import Helmet from 'react-helmet';


class Home extends Component {

    state = {
        hideChildren: false,
    }

    // Grab the context!
    static contextType = LanguageContext;

    render() {
        return (
            <>
                <NowHiring {...this.props} />
                <Wrapper {...this.props} addClass="home">
                
                        {this.props.lang !== 'fr' ?
                            <Helmet>
                                <title>A&W Canada - Home of the Burger Family</title>
                                <meta name="description" content="Find out what’s cooking at A&W. From tasty burgers to crispy onion rings to frosty mugs of Root Beer to the plant-based Beyond Meat Burger, we’ve got it all." />
                                <meta name="keywords" content="a&w canada, home, burger, root beer, onion rings, chicken, breakfast" />
                                <link rel="canonical" href="https://web.aw.ca" />
                            </Helmet>
                        :
                            <Helmet>
                                <title>A&W Canada - Découvrez la famille Burger.</title>
                                <meta name="description" content="On a tout ce qu’il vous faut chez A&W, que ce soit de délicieux burgers, des rondelles d'oignon croustillantes, des bocks de Root Beer givrés ou le Burger Beyond Meat à base de plantes." />
                                <meta name="keywords" content="a&w Canada, accueil, burger, root beer, rondelles d'oignon, poulet, déjeuner" />
                                <link rel="canonical" href="https://web.aw.ca/fr" />
                            </Helmet>
                        }
                    
                
                    <div className="blockwrap hero">
                        <div className="container">
                        
                            <Suspense fallback={<div>loading</div>}><HeroLTO {...this.props} lang={this.context.language} /></Suspense>  
                            <SubPromo1 {...this.props} />
                            <SubPromo2 {...this.props} />
                           
                            
                        </div>
                    </div>                
                </Wrapper>
            </>
        )
    }
}
export default withRouter(Home);

/*

                    <div className="blockwrap mobile-banner">
                        <MobileOrderBanner lang={this.props.lang} />
                    </div>
*/